import { IUploadImageResponse } from "../entities-generated/models/image-metadata/upload-image-response";
import { ApiClient } from "./admin-api-client";

class ImageApiClientClass {
  public removeImage(fileName: string) {
    const fn = fileName.substring(fileName.lastIndexOf('/') + 1);
    return ApiClient.del<void>(`images/${fn}`);
  }

  public uploadImage(files: File[]) {
    return ApiClient.upload<IUploadImageResponse>('images', files, 'post');
  }
}

export const ImageApiClient = new ImageApiClientClass();